import cns from 'classnames'

import { ReactComponent as Logo } from 'assets/logo.svg'

import s from './DrawerLogo.module.scss'

type Props = {
  href?: string
  className?: string
}

export function DrawerLogo({ href, className }: Props) {
  const props = {
    className: cns(s.logo, className),
    children: <Logo />,
  }

  if (href) {
    return (
      <a href={href} className={props.className}>
        {props.children}
      </a>
    )
  }

  return <div {...props} />
}
